import { onBeforeUnmount, onMounted, readonly } from "vue";

const clocks = new Map<
  string,
  { users: number; timer: ReturnType<typeof setInterval> }
>();

export function useHydrationClock(key: string) {
  const stateKey = `hydration-clock:${key}`;
  const now = useState<number>(stateKey, () => Date.now());

  onMounted(() => {
    now.value = Date.now();
    const existing = clocks.get(stateKey);
    if (existing) {
      existing.users += 1;
      return;
    }

    clocks.set(stateKey, {
      users: 1,
      timer: setInterval(() => {
        now.value = Date.now();
      }, 30_000),
    });
  });

  onBeforeUnmount(() => {
    const existing = clocks.get(stateKey);
    if (!existing) return;

    existing.users -= 1;
    if (existing.users > 0) return;

    clearInterval(existing.timer);
    clocks.delete(stateKey);
    now.value = Date.now();
  });

  return readonly(now);
}
